const TXN_RATE_LIST = {
    reducedTxnRate: 0.014,
    charityRatePercentage: 0.022,
    charityRate: 0.30,
    AT: {
        standardTxnRate: 0.034,
        standardCharityRate: 0.35,
        ppccTxnRate: 0.019,
        ppccCharityRate: 0.35
    },
    AU: {
        standardTxnRate: 0.026,
        standardCharityRate: 0.30,
        ppccTxnRate: 0.011,
        ppccCharityRate: 0.30
    },
    BE: {
        standardTxnRate: 0.034,
        standardCharityRate: 0.35,
        ppccTxnRate: 0.017,
        ppccCharityRate: 0.35
    },
    BR: {
        standardTxnRate: 0.0479,
        standardCharityRate: 0.60,
        ppccTxnRate: 0.0325,
        ppccCharityRate: 0.15
    },
    CA: {
        standardTxnRate: 0.029,
        standardCharityRate: 0.30,
        ppccTxnRate: 0.016,
        ppccCharityRate: 0.30
    },
    DE: {
        standardTxnRate: 0.0249,
        standardCharityRate: 0.35,
        ppccTxnRate: 0.015,
        ppccCharityRate: 0.35
    },
    ES: {
        standardTxnRate: 0.0290,
        standardCharityRate: 0.35,
        ppccTxnRate: 0.019,
        ppccCharityRate: 0.35
    },
    FR: {
        standardTxnRate: 0.0290,
        standardCharityRate: 0.35,
        ppccTxnRate: 0.014,
        ppccCharityRate: 0.35
    },
    GB: {
        standardTxnRate: 0.034,
        standardCharityRate: 0.20,
        ppccTxnRate: 0.014,
        ppccCharityRate: 0.20,
        paypalCardReaderStd1: 0.0275,
        paypalCardReaderStd2: 0.015,
        paypalCardReaderCon: 0.01
    },
    IE: {
        standardTxnRate: 0.029,
        standardCharityRate: 0.35,
        ppccTxnRate: 0.019,
        ppccCharityRate: 0.35
    },
    IT: {
        standardTxnRate: 0.034,
        standardCharityRate: 0.35,
        ppccTxnRate: 0.018,
        ppccCharityRate: 0.35
    },
    MX: {
        standardTxnRate: 0.034,
        standardCharityRate: 0.35,
        ppccTxnRate: 0.0295,
        ppccCharityRate: 4.0
    },
    NL: {
        standardTxnRate: 0.0395,
        standardCharityRate: 4,
        ppccTxnRate: 0.015,
        ppccCharityRate: 0.35
    },
    PL: {
        standardTxnRate: 0.029,
        standardCharityRate: 0.80,
        ppccTxnRate: 0.019,
        ppccCharityRate: 1.35
    },
    PT: {
        standardTxnRate: 0.029,
        standardCharityRate: 0.35,
        ppccTxnRate: 0.019,
        ppccCharityRate: 0.35
    },
    SE: {
        standardTxnRate: 0.034,
        standardCharityRate: 3.25,
        ppccTxnRate: 0.019,
        ppccCharityRate: 3.25
    },
    US: {
        standardTxnRate: 0.029,
        standardCharityRate: 0.30,
        ppccTxnRate: 0.022,
        ppccCharityRate: 0.30,
        paypalCardReaderStd1: 0.027
    }
},
    APP_CONSTANTS = {
        confirmed: 'Confirmed',
        inProgress: 'In Progress',
        revoked: 'Revoked',
        charityMCCCode: 8398,
        cddPolicy: 'CDD',
        cra: 'CHARITY_REG_REVENUE_AGENCY'
    },
    ALLOWED_COUNTRY_LIST = ['US', 'GB', 'UK', 'CA', 'AU', 'DE', 'ES', 'FR', 'IT', 'NL', 'PL', 'PT', 'BR', 'MX'],
    NEW_DASHBOARD_COUNTRIES = ['CA', 'AU', 'DE', 'ES', 'FR', 'IT', 'NL', 'PL', 'PT', 'BR', 'MX'],
    TECHSOUP_SUPPORTED_COUNTRIES = ['CA', 'BR', 'MX'],
    KYC_COUNTRY_LIST = ['DE', 'ES', 'FR', 'IT', 'NL', 'PL', 'PT'],
    CDD_ONLY_SHARECONSENT = ['BR', 'MX'],
    ALLOWED_UK_BUSINESS_TYPE = ['CORPORATION', 'PRIVATE_CORPORATION', 'NONPROFIT', 'GOVERNMENT'];

module.exports = {
    txnRateList: TXN_RATE_LIST,
    allowedCountryList: ALLOWED_COUNTRY_LIST,
    eligibleUKBusinesstype: ALLOWED_UK_BUSINESS_TYPE,
    newDashboardCountries: NEW_DASHBOARD_COUNTRIES,
    techsoupSupportedCountries: TECHSOUP_SUPPORTED_COUNTRIES,
    kycCountryList: KYC_COUNTRY_LIST,
    CDDForOnlyShareConsent: CDD_ONLY_SHARECONSENT,
    APP_CONSTANTS: APP_CONSTANTS
};



// WEBPACK FOOTER //
// /causemisspiggynodeweb-ci-9188/workspace/Release/constants/constants_ppcc.js